import { getAccessToken, setAccessToken, getRefreshToken, setRefreshToken, setIdToken } from "./localStorage";
import { ApplicationType } from "@/types/common";
import { UpdatePasswordError } from "./UpdatePasswordError";
import { fetchRefreshAccessToken } from "@/api/auth/fetchAuth";
import { fetchAPI } from "./fetchAPI";

let count = 0;

type FetchProps = {
  url: string;
  options: RequestInit;
  application?: ApplicationType;
};

export const fetchAPIAuth = async ({ url, options, application }: FetchProps) => {
  console.log("=>  url:", url);
  const token = getAccessToken();
  let baseURL = process.env.REACT_APP_API_AUTH;

  const response = await fetch(`${baseURL}${url}`, {
    headers: {
      ...(options.headers || {}),
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-App-Version": "web",
      ...(token ? { Authorization: `Bearer ${token.split('"')[1]}` } : {}),
    },
    ...options,
  });

  if (!response) {
    throw new Error("server_error");
  }

  const parsedResponse = await response.json();

  if (response.status === 401 && parsedResponse.errorCode === 13100) {
    console.log("in throw error");
    throw new UpdatePasswordError(parsedResponse?.code);
  }
  if (parsedResponse?.message === "Invalid token") {
    setAccessToken("");
    setIdToken("");
    window.location.replace("/welcome");
    throw new Error("session_expired");
  }
  if (response.status === 401 && (parsedResponse?.message === "The incoming token has expired" || parsedResponse?.message === "Unauthorized")) {
    if (count >= 3) {
      setAccessToken("");
      setIdToken("");
      window.location.replace("/welcome");
      throw new Error("session_expired");
    }

    const refreshToken = getRefreshToken();

    if (refreshToken) {
      try {
        let result = await fetchRefreshAccessToken({
          refreshToken: refreshToken?.split('"')[1],
        });
        const resultParsed = await result.json();

        console.log("refresh", resultParsed);
        setAccessToken(resultParsed.accessToken);
        setRefreshToken(resultParsed.refresh);
        count += 1;
        return fetchAPI({ url, options });
      } catch (e) {
        setAccessToken("");
        setIdToken("");
        window.location.replace("/welcome");
      }
    } else {
      setAccessToken("");
      setIdToken("");
      window.location.replace("/welcome");
    }
  }

  if (response.status > 206) {
    throw new Error(parsedResponse?.message);
  }

  return parsedResponse;
};
